/**
 * Specifies at what level / granularity the prep charge is applied.
 */
export enum PrepChargeGranularity {
  PER_BOX = "PER_BOX",
  PER_UNIT = "PER_UNIT",
  PER_CONTAINER = "PER_CONTAINER",
  PER_KIT = "PER_KIT",
}
